import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import ProjectModal from "./ProjectModal";

const Projects = () => {
  const [projectModalData, setProjectModalData] = useState(null);
  const plans = [
    {
      id: 1,
      title: "Audit 360 - AI Compliance Tool for UX4G (MeitY)",
      image: "https://raw.githubusercontent.com/kasifraza/public-image-host/908fee6acb047716d5d6a28ba515d823645acf78/audit-360-landing-page.png",
      description: "Developed an automated AI-based audit tool for UX4G under the Ministry of Electronics and Information Technology (MeitY). The tool crawls government websites using Puppeteer, captures screenshots, and utilizes OpenAI to analyze them against UX4G, GIGW, and DBIM compliance guidelines. It generates comprehensive compliance scores and reports.",
      techStack: "NestJS, MongoDB, Redis, RabbitMQ, OpenAI API, Puppeteer"
    },
    {
      id: 2,
      title: "IAS Community Portal & Subscription Platform",
      image: "https://raw.githubusercontent.com/kasifraza/public-image-host/908fee6acb047716d5d6a28ba515d823645acf78/ias-landing-page.png",
      description: "Built a dedicated portal for the IAS community allowing blog posting and knowledge sharing. Integrated Airpay payment gateway for managing premium subscriptions and membership access.",
      techStack: "NestJS, MySQL, Airpay Payment Gateway"
    },
    {
      id: 3,
      title: "National Book Trust of India App Backend",
      image: "https://raw.githubusercontent.com/kasifraza/public-image-host/908fee6acb047716d5d6a28ba515d823645acf78/nbt-app-home-page.jpeg",
      images:[
        "https://raw.githubusercontent.com/kasifraza/public-image-host/908fee6acb047716d5d6a28ba515d823645acf78/nbt-app-home-page.jpeg",
        "https://raw.githubusercontent.com/kasifraza/public-image-host/908fee6acb047716d5d6a28ba515d823645acf78/nbt-app-login.jpeg",
        "https://raw.githubusercontent.com/kasifraza/public-image-host/908fee6acb047716d5d6a28ba515d823645acf78/nbt-app-orders.jpeg",
        "https://raw.githubusercontent.com/kasifraza/public-image-host/908fee6acb047716d5d6a28ba515d823645acf78/nbt-app-profile.jpeg",
        "https://raw.githubusercontent.com/kasifraza/public-image-host/908fee6acb047716d5d6a28ba515d823645acf78/nbt-app-search.jpeg"
      ],
      description: "Developed the robust backend infrastructure for the National Book Trust of India mobile application.",
      techStack: "NestJS, Redis, MySQL, Paytm Payment Gateway"
    },
    {
      id: 4,
      title: "Warehouse Monitoring System (West Bengal Govt)",
      image: "https://raw.githubusercontent.com/kasifraza/public-image-host/refs/heads/main/wait-homepage.png",
      images:[
        "https://raw.githubusercontent.com/kasifraza/public-image-host/refs/heads/main/wait-homepage.png",
        "https://raw.githubusercontent.com/kasifraza/public-image-host/refs/heads/main/wait-admin-panel.png",
        "https://raw.githubusercontent.com/kasifraza/public-image-host/refs/heads/main/wait-warehouse-detail.png"
      ],
      description: "Designed a centralized AI-powered dashboard for warehouse monitoring. Utilized Python and YOLO models for real-time video analysis from NVR/RTSP streams to perform sack bag counting. Implemented ANPR for truck number plate recognition and weight integration at weighbridges. Features multi-role access for Warehouse In-charge, District, and State officers.",
      techStack: "Python, YOLO, ANPR, Node.js, RTSP Stream Analysis, PostGres, Redis, RabbitMQ, NextJs,Tailwind,Twillio"
    },
    {
      id: 5,
      title: "Unified Media Upload Service",
      image: "/media-service.webp",
    },
    {
      id: 6,
      title: "BachatWala - Grocery Price Comparison Mobile App",
      image: "https://res.cloudinary.com/dyvhryjbe/image/upload/v1733452276/bachatwala/bachatwala-home-page.jpg",
      images: [
        "https://res.cloudinary.com/dyvhryjbe/image/upload/v1733452276/bachatwala/bachatwala-home-page.jpg",
        "https://res.cloudinary.com/dyvhryjbe/image/upload/v1733452276/bachatwala/bachatwala-searchbar-home-page.jpg",
        "https://res.cloudinary.com/dyvhryjbe/image/upload/v1733452276/bachatwala/bachatwala-searched-products-tab.jpg",
        "https://res.cloudinary.com/dyvhryjbe/image/upload/v1733452275/bachatwala/bachatwala-comparison-page.jpg"
      ]
    },
    {
      id: 7,
      title: "No Code Low Code Platform using Nocobase",
      image: "/nocobase.jpeg",
    },
  ];

  return (
    <>
      <div className="w-full relative z-[10] py-10">
        <h2 className="mb-6 text-2xl font-bold text-center text-gray-300">Recent Projects</h2>
        <Swiper
          effect={"coverflow"}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={"auto"}
          initialSlide={4}
          spaceBetween={20}
          coverflowEffect={{
            rotate: 30,
            stretch: 0,
            depth: 10,
            modifier: 1,
            slideShadows: true,
          }}
          pagination={false}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          modules={[EffectCoverflow, Pagination, Navigation]}
          className="w-full mySwiper-projects"
        >
          {plans.map((plan) => (
            <SwiperSlide key={plan.id} onClick={() => setProjectModalData(plan)} >
              <img
                src={plan.image}
                alt={plan.title}
                className="object-cover w-full h-64 rounded-lg"
              />
              <p className="px-2 mt-2 text-sm font-semibold text-center text-gray-100 text-wrap">
                {plan.title}
              </p>
            </SwiperSlide>

          ))}
          <div className="swiper-button-prev">
            <FaArrowLeft />
          </div>
          <div className="swiper-button-next">
            <FaArrowRight />
          </div>
        </Swiper>
      </div>

      {projectModalData && (
        <ProjectModal
          title={projectModalData.title}
          // Pass description and techStack if your ProjectModal supports it, 
          // otherwise it will just show images/title as before.
          description={projectModalData.description}
          techStack={projectModalData.techStack}
          images={projectModalData.images || [projectModalData.image]}
          projectModalOpen={!!projectModalData}
          setProjectModalOpen={() => setProjectModalData(null)}
        />
      )}
      <style jsx>{`
        .mySwiper-projects {
          padding: 30px 0;
        }
        .mySwiper-projects .swiper-slide {
          width: 300px;
          height: 100%;
          min-height: 300px;
        }
        .mySwiper-projects .swiper-button-prev,
        .swiper-button-next {
          color: #60a5fa;
        }
      `}</style>
    </>
  );
};

export default Projects;